import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { HttpClient } from "@angular/common/http";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
// const EXCEL_EXTENSION = '.xlsx';
const EXCEL_EXTENSION = '.xls';

@Injectable()
export class ExcelService {

  constructor(public http: HttpClient) {

  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    // FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }
  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xls', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  public jsonToBase64XLS(json: any[]) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xls', type: 'base64' });
    return excelBuffer;
  }


  public excelToJson(url) {
    let result = {};
    let req = new XMLHttpRequest();
    req.open("GET", url, true);
    req.responseType = "arraybuffer";
    req.onload = (e) => {
      var arraybuffer = req.response;

      /* convert data to binary string */
      var data = new Uint8Array(arraybuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");

      /* Call XLSX */
      var workbook = XLSX.read(bstr, {
        type: "binary"
      });

      /* DO SOMETHING WITH workbook HERE */
      var first_sheet_name = workbook.SheetNames[0];
      /* Get worksheet */
      var worksheet = workbook.Sheets[first_sheet_name];
      XLSX.utils.sheet_to_json(worksheet, {
        raw: true
      }).forEach(i => {
        // Chi nhánh: "VP KBNN TRA VINH"
        // Mã chi nhánh Ngân hàng thụ hưởng: "84701001"
        result[i['Chi nhánh']] = i['Mã chi nhánh Ngân hàng thụ hưởng'];

      });
      console.log(JSON.stringify(result));
    };
    req.send();
  }
  getDataFromFile(file, cb){
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
          let arrayBuffer:any = fileReader.result;
          let data = new Uint8Array(arrayBuffer);
          let arr = [];
          for(var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          let bstr = arr.join("");
          let workbook = XLSX.read(bstr, {type:"binary"});
          let first_sheet_name = workbook.SheetNames[0];
          let worksheet = workbook.Sheets[first_sheet_name];
          cb(XLSX.utils.sheet_to_json(worksheet,{raw:true}))
      };
      fileReader.readAsArrayBuffer(file);
  }


}
